import { render, staticRenderFns } from "./Commercial.html?vue&type=template&id=2b79d595&scoped=true&external"
import script from "./Commercial.vue?vue&type=script&lang=js"
export * from "./Commercial.vue?vue&type=script&lang=js"
import style0 from "./Commercial.scss?vue&type=style&index=0&id=2b79d595&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79d595",
  null
  
)

export default component.exports